import validator from 'validator';

export type SchemaValidationResult<T> = { [key in keyof T]?: string[] } | undefined;

export type PropertySchema = {
    type: 'string';
    equality?: string;
    format?: { pattern: string | RegExp; flags?: string; message: string };
    length?: { maximum?: number };
    presence?: { allowEmpty?: boolean };
    inclusion?: string[];
};

const validateSchema = <T>(value: T, schema: { [key in keyof T]?: PropertySchema }): SchemaValidationResult<T> =>
{
    const errors: SchemaValidationResult<T> = {};

    for (const key in schema) {
        const property = schema[key];
        const val = (value as any)[key];

        if (property) {
            errors[key] = [];

            if (property.presence && !property.presence.allowEmpty && (!val || validator.isEmpty(val))) {
                errors[key]?.push(`${key  } is required and cannot be empty`);
            }

            if (val) {
                if (property.length && property.length.maximum && !validator.isLength(val, { max: property.length.maximum })) {
                    errors[key]?.push(`Value exceeds maximum length of ${property.length.maximum}`);
                }

                if (property.format &&
                    ((typeof property.format.pattern === 'string' && !validator.matches(val, property.format.pattern, property.format.flags)) ||
                    (property.format.pattern instanceof RegExp && !validator.matches(val, property.format.pattern)))) {
                    errors[key]?.push(property.format.message);
                }

                if (property.inclusion && !property.inclusion.includes(val)) {
                    errors[key]?.push(`Value must be one of: ${property.inclusion.join(', ')}`);
                }

                if (property.equality && val !== (value as any)[property.equality]) {
                    errors[key]?.push(`Value must be equal to ${property.equality}`);
                }
            }

            if (errors[key]?.length === 0) {
                delete errors[key];
            }
        }
    }

    return Object.keys(errors).length > 0 ? errors : undefined;
};

export const Validator = {
    validateSchema,
};
